import React, { Fragment, useEffect, useState } from "react"
import Input from "components/Input"
import { FormProvider, useForm } from "react-hook-form"
import { withTranslation } from "react-i18next"
import { filterValues } from 'Helper'
import { FormBtn } from 'components/Btn'
import useSWR from "swr"
import { apiRequest } from "store/Misc/apiRequest"
import { Checkbox, FormControlLabel } from "@mui/material"
import { toast } from "react-toastify"
export default withTranslation()(function PermissionManagement({ t }) {
  const method = useForm({
    mode: 'all'
  })
  const { handleSubmit, register, watch, formState: { isValid, isDirty } } = method
  const { data: roles } = useSWR('user-mgmt/roles')
  const { data: permissions } = useSWR('user-mgmt/all-permissions')
  const { data: userPermissions } = useSWR(`user-mgmt/get-user-permissions/${watch('role_id')}`)
  const [permissionObj, setPermissionObj] = useState({})

  useEffect(() => {
    if (userPermissions && permissions) {
      setPermissionObj(
        Object.fromEntries(
          permissions.data
            .map(x => x.sub_permissions
              .map(x => x.name))
            .flat(1)
            .map(x => [x, userPermissions.data.includes(x)])
        )
      )
    }
  }, [permissions, userPermissions])

  const edit = (name, e) => {
    setPermissionObj({ ...permissionObj, [name]: !permissionObj[name] })
  }

  const submit = async (payload) => {
    let names = Object.entries(permissionObj).filter(x => x[1] && x[1]).map(x => x[0])
    let permissionsIds = permissions.data
      .map(x => x.sub_permissions
        .map(x => [x.name, x.id]))
      .flat(1)
      .filter(x => names.includes(x[0]))
      .map(x => x[1])
    // console.log(Object.values(permissionObj).filter(x => x && x))
    if (watch('role_id')) {
      await apiRequest({
        method: 'post',
        url: 'user-mgmt/assign-permissions-to-roles',
        payload: { role_id: watch('role_id'), permissions: permissionsIds }
      })
      toast.success('Permissions updated successfully')
    } else { toast.warn('Select a role') }
  }
  return (
    <>
      <FormProvider {...method}>
        <form onSubmit={handleSubmit(submit)}>
          <div className="p-8 bg-white rounded-lg mb-8">
            <div className="flex">
              <label className="font-bold text-2xl block mb-5 grow">Permission managment</label>
              <FormBtn
                content={t('misc.submit')}
                className="bg-primary"
                disabled={!isValid || !isDirty}
              />
            </div>
            <Input
              name="role_id"
              label={t('settings.permission.label')}
              options={roles?.data ? filterValues({ options: roles.data, param: { value: 'id', label: 'display_name' } }) : []}
            // defaultValue={{ label: 'Cachier', value: 17 }}
            />
          </div>
          {
            watch('role_id')
              ?
              permissions?.data && userPermissions ? <>
                {
                  permissions.data.map(permission => {
                    return (
                      <div className="p-8 bg-white rounded-lg mb-8" key={permission.id.toString()}>
                        <>
                          <label className="font-bold text-2xl block mb-5">{`${permission.name.charAt(0).toUpperCase()}${permission.name.slice(1)}`}</label>
                          <div className="grid grid-cols-3 gap-8 gap-y-3">
                            {
                              permission.sub_permissions.map(({ name, id }) => {
                                // console.log(permissionObj[name], name)
                                return (
                                  <Fragment key={name}>
                                    <FormControlLabel
                                      control={
                                        <><Checkbox name={name} {...register(name)} checked={permissionObj[name] ? true : false} onChange={(e) => edit(name, e)} defaultValue={id} value={id} /> </>
                                      }
                                      label={`${name.split('_')[0].charAt(0).toUpperCase()}${name.split('_')[0].slice(1)} ${name.split('_')[1]}`}
                                    />
                                  </Fragment>
                                )
                              })
                            }
                          </div>
                        </>
                      </div>
                    )
                  })
                }
              </> : null
              : 'Please select a role to view its permissions'
          }
        </form>
        {/* <OverviewPermission />
            <TransactionPermission />
            <RedemptionVaultPermission />
            <PromoPermission />
            <POSPermission />
            <SettlementPermission />
            <ReviewPermission />
            <SettingsPermission /> */}
      </FormProvider>
    </>
  )
})